var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "copy-element" },
    [
      _c("CompassLink", {
        attrs: {
          label: _vm.linkLabel,
          link: _vm.url,
          type: _vm.color,
          target: _vm.blank ? "_blank" : "_self"
        }
      }),
      _vm._v(" "),
      _vm.linkLabel
        ? _c("SaasClipboard", { attrs: { data: _vm.linkLabel } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }